import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@radix-ui/react-tooltip";
import moment from "moment";
// import { useEffect, useState } from "react";
import { switchString, stockistDatadisplaySequence } from "src/utils/utils";

interface IDetailsGrid {
  dataObj: any;
  keyString?: (input: string) => string | undefined;
  className?: string;
  removeNestedData?: boolean;
}

const verifyStringType = function (input: string) {
  const numberRegex = /^\d+$/;

  if (!numberRegex.test(input)) {
    const dateMoment = moment(input, moment.ISO_8601, true); // Use ISO 8601 format for strict parsing

    if (dateMoment.isValid()) {
      return dateMoment.format("DD MMM, YYYY"); // Corrected format to display the year correctly
    }
  }

  return input;
};

const StockistDetailsGrid = ({ dataObj, keyString, className, removeNestedData }: IDetailsGrid) => {
  const keyChangeFn = keyString || switchString;

  // const [_ ,setData] = useState<any>(dataObj || {});

  const appendSpecificNestedValues = (acc: any, dataObj: any) => {
    const nestedFieldsToAppend: Record<string, any> = {
      medvol_field: dataObj?.medvol_field?.Name || null,
      elnv_invoice: dataObj?.elnv_invoice?.einvack_type_desc || null,
      city_name: dataObj?.city?.city_name || null,
    };

    for (const [key, value] of Object.entries(nestedFieldsToAppend)) {
      if (value) {
        acc[key] = value;
      }
    }
  };

  const processedDataObj =
    removeNestedData && dataObj
      ? Object.keys(dataObj).reduce((acc: any, key: any) => {
          if (typeof dataObj[key] !== "object") {
            acc[key] = dataObj[key];
          }
          appendSpecificNestedValues(acc, dataObj);
          return acc; // This line is added to return the accumulator
        }, {})
      : dataObj;
  // This should be outside the reduce function

  // useEffect(() => {
  //   if(processedDataObj && removeNestedData)
  //    setData(processedDataObj);
  // }, []);

  return (
    <div className={className ? className : "grid w-10/12 grid-cols-1 mt-5 xl:grid-cols-2 gap-x-20 gap-y-5"}>
      {processedDataObj &&
        Object.keys(processedDataObj).length > 0 &&
        stockistDatadisplaySequence.map(
          (key) =>
            processedDataObj[key] &&
            keyChangeFn(key) && (
              <div key={key?.toString()} className="grid grid-cols-2 text-base">
                <p className="text-[#49484C] place-self-center mr-auto whitespace-break-spaces text-base leading-[0.02rem] font-normal not-italic">
                  {keyChangeFn(key)}
                </p>
                <div className="mr-auto">
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger className="cursor-text" asChild>
                        <div className="flex">
                          <p className="text-[#1B1A1F] text-base font-semibold text-left mr-auto">
                            {typeof processedDataObj[key] === "string" || typeof processedDataObj[key] === "number"
                              ? verifyStringType(processedDataObj[key]?.toString())?.length > 20
                                ? verifyStringType(processedDataObj[key]?.toString()).slice(0, 20) + "..."
                                : verifyStringType(processedDataObj[key]?.toString())
                              : ""}
                          </p>
                        </div>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p className="text-[#1B1A1F] mr-auto">
                          {typeof processedDataObj[key] === "string" ? verifyStringType(processedDataObj[key]) : ""}
                        </p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </div>
              </div>
            )
        )}
    </div>
  );
};

export default StockistDetailsGrid;
